module.exports = __webpack_public_path__ + "img/500-1000.33f27475.png";